import React from "react";

interface LoadingProps {
  fullScreen?: boolean;
  text?: string;
}

const Loading: React.FC<LoadingProps> = ({
  fullScreen = true,
  text = "Chargement..."
}) => {

  const content = (
    <div className="flex flex-col items-center justify-center text-center gap-6 w-full">

      {/* LOGO */}
      <img
        src="/assets/logo/favicon.png"
        alt="NISSI GROUP INTL"
        className="w-16 h-16 object-contain mx-auto"
      />

      {/* SCAN LOADER */}
      <div className="relative flex justify-center items-end gap-1 h-6 w-32 overflow-hidden mx-auto">

        {/* BARRES */}
        {[0, 1, 2, 3, 4].map((i) => (
          <span
            key={i}
            className="w-2 h-full bg-white/20 rounded-sm"
          />
        ))}

        {/* SCANNER */}
        <span className="absolute top-0 left-0 h-full w-8 bg-primary/80 blur-sm animate-scan" />

      </div>

      {/* TEXT */}
      <p className="text-sm text-white/70 tracking-wide text-center">
        {text}
      </p>

    </div>
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-dark/95 backdrop-blur-md">
        {content}
      </div>
    );
  }

  return <div className="py-10 flex justify-center">{content}</div>;
};

export default Loading;